import { render, staticRenderFns } from "./ManuallyInputSummary.vue?vue&type=template&id=088df347"
import script from "./ManuallyInputSummary.vue?vue&type=script&lang=ts"
export * from "./ManuallyInputSummary.vue?vue&type=script&lang=ts"
import style0 from "./manually-input-summary.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports